import React, { FC } from 'react'

import { Txt } from 'src/components/atoms'
import { RequiredLabel } from 'src/components/molecules'

type Props = {
  title: string
  children: React.ReactNode
  className?: string
}

export const ChangePasswordItem: FC<Props> = ({ title, children, className }) => {
  return (
    <div className={className}>
      <div className="tw-flex tw-flex-col tw-w-full">
        <Txt sizeType="s" className="tw-text-standardText-secondary tw-mb-s-4">
          {title}
        </Txt>
        <div className="tw-h-fit tw-relative">
          <div className="tw-absolute tw-h-full -tw-left-s5 tw-centering">
            <RequiredLabel className="tw-w-fit" />
          </div>
          {children}
        </div>
      </div>
    </div>
  )
}
